var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "teas-prefileiframe-page" },
    [
      _c("DsfMobileNavBar", {
        staticClass: "prefileiframe-head",
        attrs: { navTitle: _vm.title },
      }),
      _c("iframe", {
        staticClass: "prefileiframe-content",
        attrs: { src: _vm.url },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }